<template>
  <Modal
    v-model="modalVisible"
    :cancelText="numEligibleUsers ? 'cancel' : ''"
    :handleMainAction="handleMainAction"
    headerText="Remove MFA Requirement on User Portal"
    :mainActionText="numEligibleUsers ? 'remove requirement' : 'ok'"
  >
    <div v-if="numEligibleUsers">
      <p>
        {{ numEligibleUsers }} of {{ selectedItems.length }} selected users
        have a requirement to remove.
      </p>
      <p>
        Are you sure you would like to remove the requirement for MFA on the User Portal
        for {{ thisText }} {{ userText }}?
      </p>
    </div>
    <div v-else>
      <p>
        Selected users do not have a requirement for MFA to remove.
      </p>
    </div>
  </Modal>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import _ from 'lodash';
import mfaEnrollmentMixin from 'components/mixins/mfaEnrollmentMixin';
import mfaModalMixin from 'components/Modal/mfaModals/mfaModalMixin';
import pluralize from 'pluralize';

const { error, success } = Constants.default;

export default {
  name: 'UserDisableMFAModal',

  mixins: [
    mfaEnrollmentMixin,
    mfaModalMixin,
  ],

  computed: {
    ...mapGetters('SystemUserCollection', {
      ineligibleUsers: 'getUsersIneligibleForMFADisablement',
      selectedItems: 'getSelectedItems',
    }),

    numEligibleUsers() {
      return this.selectedItems.length - this.ineligibleUsers.length;
    },

    thisText() {
      return pluralize('this', this.numEligibleUsers);
    },

    userText() {
      return pluralize('user', this.numEligibleUsers);
    },
  },

  methods: {
    ...mapActions('SystemUserCollection', [
      'unselectItems',
      'updateItems',
    ]),

    /**
     * Disables MFA for users that are selected
     */
    disableMFAForUsers() {
      const numUsers = this.selectedItems.length;
      this.updateItems({
        ids: this.selectedItems,
        attributes: {
          enable_user_portal_multifactor: false,
          mfa: { exclusion: false },
        },
      })
        .then((response) => {
          if (_.get(response, 'numSuccess')) {
            const notifyText = (numUsers === 1)
              ? '1 user was successfully updated.'
              : `${response.numSuccess} of ${numUsers} users were successfully updated.`;
            this.unselectItems({ ids: this.selectedItems });
            notify(success, notifyText);
          } else {
            const usersNoun = pluralize('user', numUsers);
            notify(error, `Error updating ${usersNoun}.`);
          }
        });
    },

    /**
     * Executes when the user clicks the main action button in the modal.
     * Disables MFA for the selected users. If there are users that cannot have MFA
     * disabled, these users will be unselected.
     */
    handleMainAction() {
      if (!this.numEligibleUsers) {
        this.hideModal();
        return;
      }

      // Disable MFA for selected users
      this.hideModal();
      if (this.ineligibleUsers.length) {
        this.unselectItems({ ids: this.ineligibleUsers.map(item => item.id) });
      }
      this.disableMFAForUsers();
    },
  },
};
</script>
